import { useState, useCallback } from 'react';

type DocumentType = 'terms' | 'privacy' | 'faq';

export const useLegalDocumentModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [documentType, setDocumentType] = useState<DocumentType | null>(null);

  const openDocument = useCallback((type: DocumentType) => {
    setDocumentType(type);
    setIsOpen(true);
  }, []);

  const closeDocument = useCallback(() => {
    setIsOpen(false);
    setDocumentType(null);
  }, []);

  return {
    isOpen,
    documentType,
    openDocument,
    closeDocument
  };
};